import { render, staticRenderFns } from "./createWxOrder.vue?vue&type=template&id=18bb2ef2&scoped=true"
import script from "./createWxOrder.vue?vue&type=script&lang=js"
export * from "./createWxOrder.vue?vue&type=script&lang=js"
import style0 from "./createWxOrder.vue?vue&type=style&index=0&id=18bb2ef2&prod&scoped=true&lang=css"
import style1 from "./createWxOrder.vue?vue&type=style&index=1&id=18bb2ef2&prod&lang=css"
import style2 from "./createWxOrder.vue?vue&type=style&index=2&id=18bb2ef2&prod&scoped=true&lang=scss"
import style3 from "./createWxOrder.vue?vue&type=style&index=3&id=18bb2ef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bb2ef2",
  null
  
)

export default component.exports